export const getCurrentCountry = () => {
    return process.env.COUNTRY || 'ukraine';
};

export const getCountryDisplayName = (country: string) => {
    if (country.includes('-')) {
        const parts = country.split('-');
        return parts[1].toUpperCase();
    } else {
        return country.toUpperCase();
    }
};
